import { sections as sectionsUtils } from '#packages/util';
import { addBlankSectionToEmptyPageIfNeeded } from '../../enforcement/addBlankSection';

import type { CutPlugin } from 'types/editorPlugins';
import type { Scope } from '#packages/sections';

const { shiftComponents, getComponentsBelowPosition } = sectionsUtils;

export const getSectionCutPlugin =
  (scope: Scope): CutPlugin =>
  async (compRef) => {
    const { editorAPI, components } = scope;
    const sectionLayout = components.layout.get_rect(compRef);

    const componentsToShift = getComponentsBelowPosition(
      editorAPI,
      sectionLayout.y + sectionLayout.height,
    );

    editorAPI.dsActions.components.remove(compRef);

    shiftComponents(editorAPI, componentsToShift, -sectionLayout.height);

    addBlankSectionToEmptyPageIfNeeded(scope);
  };
